import { contactCardValidator } from "@redotech/redo-model/brand-kit";
import * as z from "zod";

export const generateContactCard = {
  name: "generateContactCard" as const,
  input: z.object({ contactCard: contactCardValidator }),
  output: z.object({ url: z.string().optional() }),
};
